// The Studio's address names what is open, so a reload, a bookmark or a link opens it again:
//
//   /learn/studio                              anything not made from a template
//   /learn/studio/<templateId>                 a template being edited (built-in such as
//                                              product-career-fit, or a saved one)
//   /learn/studio/<templateId>/<output>        what it becomes, in the editor: book, pdf, lecture
//   /learn/studio/<templateId>/<output>/<page> … read from that page
//
// A saved draft lives only in this browser, so it has no address of its own. A language
// prefix (/ko/learn/studio/…) is kept.
const STUDIO_PATH = /^((?:\/(?:ko|en|ja))?\/learn\/studio)(?:\/([A-Za-z0-9._~%-]+)(?:\/([a-z][a-z-]*)(?:\/([1-9][0-9]{0,3}))?)?)?\/?$/;

/** { base, templateId, output, page } for a Studio address, or null for any other path. */
export function readStudioAddress(pathname) {
  const match = STUDIO_PATH.exec(pathname);
  if (!match) return null;
  let templateId = null;
  if (match[2]) {
    try { templateId = decodeURIComponent(match[2]); } catch { return null; }
  }
  return { base: match[1], templateId, output: match[3] ?? null, page: match[4] ? Number(match[4]) : null };
}

/** The address of `templateId` under `base`, with the output shown and the page read, if any. */
export function studioAddress(base, templateId = null, { output = null, page = null } = {}) {
  if (!templateId) return base;
  const template = `${base}/${encodeURIComponent(templateId)}`;
  if (!output) return template;
  return page ? `${template}/${output}/${page}` : `${template}/${output}`;
}
